export enum PromotionStatus {
    Active = 1,
    Inactive = 2,
    PendingApproval = 3
}